import { render, staticRenderFns } from "./ChartLegend.vue?vue&type=template&id=803fe74a&scoped=true"
import script from "./ChartLegend.vue?vue&type=script&lang=js"
export * from "./ChartLegend.vue?vue&type=script&lang=js"
import style0 from "./ChartLegend.vue?vue&type=style&index=0&id=803fe74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803fe74a",
  null
  
)

export default component.exports